import { useTranslation } from "react-i18next";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Button
} from "@mui/material";
import * as XLSX from "xlsx";
import { EGButton } from "../../../../MainComponents/Button/EGButton/EGButton";
import { useNavigate } from "react-router-dom";

const TableComponent = ({ data, fechas  }) => {

  const [t] = useTranslation("dashboard");

  const navigate = useNavigate();
  if (!Array.isArray(data) || data.length === 0) return null;
  // Copia ordenada de mayor a menor por cantidad. NO mutar `data`:
  // es la misma referencia que usan la caché de datos y la gráfica.
  const sortedData = [...data].sort((a, b) => (b.count || 0) - (a.count || 0));
  const total = data.reduce((sum, row) => sum + (row.count || 0), 0);
  const buildReportParams = (row) => {
    const params = new URLSearchParams();
  console.log(row);
  
    // 1. Ordering fijo
    //params.set("ordering", "-created_at");
  
    // 2. Mapear filtros de este row
    row.filters?.forEach((f) => {
      const { key, value, source } = f;
  
      switch (source) {
        case "status":
          params.append("status", value);
          break;
        
        case "severity":
          params.append("kind_of_severity",value);
          break;
  
        case "tag":
          params.append("tags", key);
          break;
  
        case "metadata":
          params.append("catalog", "EG" + '::' + value);
          break;
  
        case "indicator":
          params.append(`indicator_${key}`, value);
          break;
  
        case "entryway":
          params.append("kind_of_entryways", value);
          break;
  
        default:
          params.append(source, value || key);
      }
    });
  
    // 3. Fechas desde props
    if (fechas?.inicio) {
      params.set("r_start_created", new Date(fechas.inicio).toISOString());
    }
    if (fechas?.fin) {
      params.set("r_end_created", new Date(fechas.fin).toISOString());
    }
  
    return params;
  };
  

  const handleDownloadExcel = () => {
    const rows = sortedData.map((row) => ({
      [t("TableIndicator.excel_indicator_column")]: row.label,
      [t("TableIndicator.excel_amount_column")]: row.count,
      [t("TableIndicator.excel_percentage_column")]:
        total > 0 ? `${((row.count / total) * 100).toFixed(1)}%` : "0%",
    }));

    rows.push({
      [t("TableIndicator.excel_indicator_column")]: t("TableIndicator.excel_total_row"),
      [t("TableIndicator.excel_amount_column")]: total,
      [t("TableIndicator.excel_percentage_column")]: "100%",
    });

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, t("TableIndicator.excel_sheet_name"));

    XLSX.writeFile(workbook, "tabla-indicadores.xlsx");
  };

  return (
    <>
    
      <EGButton
      label={t("TableIndicator.download_excel_button")}
      color="primary"
      onClick={handleDownloadExcel}
      />


      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell><strong>{t("TableIndicator.indicator_header")}</strong></TableCell>
            <TableCell><strong>{t("TableIndicator.amount_header")}</strong></TableCell>
            <TableCell><strong>{t("TableIndicator.percentage_header")}</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedData.map((row, i) => (
            <TableRow key={i}>
              <TableCell 
              /*onClick={() => {
                const params = buildReportParams(row);
                console.log(params);
                navigate(`/reports/all/?${params.toString()}`);
              }}*/
              // sx={{ cursor: "pointer" }}
              >{row.label}</TableCell>
              <TableCell>{row.count}</TableCell>
              <TableCell>
                {total > 0
                  ? `${((row.count / total) * 100).toFixed(1)}%`
                  : "0%"}
              </TableCell>
            </TableRow>
          ))}
          {/* Fila de totales */}
          <TableRow>
            <TableCell><strong>{t("TableIndicator.total_row")}</strong></TableCell>
            <TableCell><strong>{total}</strong></TableCell>
            <TableCell><strong>100%</strong></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};

export default TableComponent;